import api from "./../utils/api";

export const getDashboardData = async () => {
    try {
        const response = await api.get(
            `/analytic/dashboard`,
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};
